import { useState } from "react";

// custom libraries
import { Card, CustomSpinner } from '_atoms';

// bootstrap
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';

// exterior libraries
import { Flex, Subtitle, Title as TremorTitle } from '@tremor/react';
import { useTable } from 'react-table';

const TableEntry = (props) => {
    const row = props.row
    const i = props.i

    const [highlight, setHighlight] = useState(false);
    const [index, setIndex] = useState(0)

    const mouseOver = (index) => {
        if (props.clickable == false) return
        setHighlight(true)
        setIndex(index)
    }

    const mouseLeave = (index) => {
        if (props.clickable == false) return
        setHighlight(false);
        setIndex(index)
    }

    return (
        <tr
            {...row.getRowProps()}
            style={{
                backgroundColor: highlight && index == i ? '#F2F2F2' : props?.selectedId != undefined && props?.selectedId == row?.original?.transactionId ? '#F2F2F2' : props?.selectedId && props?.selectedId === row?.original?._id ? '#F2F2F2' : 'white',
                borderBottomWidth: '1px',
                borderBottomColor: '#D8D8D8',
                borderBottomStyle: 'solid',
                height: 50,
                fontSize: 12,
                cursor: props.clickable == false ? 'default' : 'pointer',
            }}
            onClick={() => { props.handleClick ? props.handleClick(i) : null }}
            onMouseOver={() => { mouseOver(i) }}
            onMouseLeave={() => { mouseLeave(i) }}
        >
            {row.cells.map(cell => {
                return <td style={{ padding: 12 }} {...cell.getCellProps()}>{cell.render("Cell")}</td>;
            })}
        </tr>
    )
}

const ClickableTable = ({ columns, data, handleClick, status, clickable, card, headers, title, subtitle, toggle, selectedId }) => {
    const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = useTable({ columns, data });


    if (card == true) {
        return (
            <div style={{ paddingBottom: 18 }}>
                <Card>

                    <Flex>
                        <div style={{ marginLeft: 12, marginBottom: 8 }}>
                            <TremorTitle>{title}</TremorTitle>
                            <Subtitle>{subtitle}</Subtitle>
                        </div>
                        {toggle}
                    </Flex>

                    {headers}
                    <Container>
                        {status == 'loading' ? <Row className="justify-content-md-center mt-3"><CustomSpinner /></Row> :

                            <div style={{ overflowY: 'scroll', height: '50em', }}>
                                <table {...getTableProps()} style={{ width: '100%' }} className='mt-2'>

                                    <thead
                                        style={{
                                            borderTopWidth: '1px',
                                            borderTopColor: '#D8D8D8'
                                        }}>
                                        {headerGroups.map(headerGroup => (

                                            <tr {...headerGroup.getHeaderGroupProps()}>
                                                {headerGroup.headers.map(column => (
                                                    <th
                                                        style={{
                                                            borderBottomWidth: '1px',
                                                            borderBottomColor: '#D8D8D8',
                                                            borderBottomStyle: 'solid'
                                                        }}
                                                        {...column.getHeaderProps()}>

                                                        <div style={{ marginTop: 14 }}>
                                                            {column.render("Header")}
                                                        </div>
                                                    </th>
                                                ))}
                                            </tr>
                                        ))}
                                    </thead>

                                    <tbody {...getTableBodyProps()}>
                                        {
                                            rows.map((row, i) => {
                                                prepareRow(row)
                                                return <TableEntry
                                                    clickable={clickable}
                                                    row={row}
                                                    i={i}
                                                    handleClick={handleClick}
                                                    selectedId={selectedId}
                                                />
                                            })
                                        }
                                    </tbody>
                                </table>
                            </div>
                        }
                    </Container>
                </Card>
            </div>
        );
    } else {
        return (
            <Container>
                {status == 'loading' ? <Row className="justify-content-md-center mt-3"><CustomSpinner /></Row> :
                    <table {...getTableProps()} style={{ width: '100%' }} className='mt-2'>

                        <thead
                            style={{
                                borderTopWidth: '1px',
                                borderTopColor: '#D8D8D8'
                            }}>
                            {headerGroups.map(headerGroup => (

                                <tr {...headerGroup.getHeaderGroupProps()}>
                                    {headerGroup.headers.map(column => (
                                        <th
                                            style={{
                                                borderBottomWidth: '1px',
                                                borderBottomColor: '#D8D8D8',
                                                borderBottomStyle: 'solid'
                                            }}
                                            {...column.getHeaderProps()}>

                                            <div style={{ marginTop: 14 }}>
                                                {column.render("Header")}
                                            </div>
                                        </th>
                                    ))}
                                </tr>
                            ))}
                        </thead>

                        <tbody {...getTableBodyProps()}>
                            {
                                rows.map((row, i) => {
                                    prepareRow(row)
                                    return (
                                        <TableEntry
                                            clickable={clickable}
                                            row={row} i={i}
                                            handleClick={handleClick}
                                            selectedId={selectedId}
                                        />
                                    )
                                })
                            }
                        </tbody>
                    </table>
                }
            </Container>
        );
    }
};

export default ClickableTable;